import { firebaseConfig } from "../firebase";

const apiBase = process.env.REACT_APP_API_BASE_URL || "/api";

export async function sendPasswordResetRequest(emailOrPhone) {
  const response = await fetch(`${apiBase}/send-password-reset`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      emailOrPhone,
      apiKey: firebaseConfig.apiKey,
    }),
  });

  const responseText = await response.text();
  let data;
  try {
    data = JSON.parse(responseText);
  } catch {
    data = null;
  }

  if (!response.ok) {
    if (response.status === 404 && data?.error === "Email/Number doesn't exist") {
      throw new Error("Email/Number doesn't exist");
    }
    if (response.status === 404) {
      throw new Error("Password reset service is unavailable. Please try again later.");
    }
    throw new Error(
      data?.error?.message ||
      data?.error ||
      data?.message ||
      "Unable to verify your email or phone number. Please try again."
    );
  }

  if (data?.success !== true) {
    throw new Error("Unable to verify your email or phone number. Please try again.");
  }

  return data;
}
